'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactContenteditable = require('react-contenteditable');

var _reactContenteditable2 = _interopRequireDefault(_reactContenteditable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPageClick = require('react-page-click');

var _reactPageClick2 = _interopRequireDefault(_reactPageClick);

var _reactKeydown = require('react-keydown');

var _reactKeydown2 = _interopRequireDefault(_reactKeydown);

var _helper = require('../../helpers/helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var Editable = (_dec = (0, _reactKeydown2.default)(13), (_class = function (_Component) {
	(0, _inherits3.default)(Editable, _Component);

	function Editable(props) {
		(0, _classCallCheck3.default)(this, Editable);

		var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Editable).call(this, props));

		_this.state = {
			canEdit: true,
			hasChanged: false,
			clear: _this.props.clear,
			html: _this.props.html
		};
		(0, _helper.bindAll)(_this);
		return _this;
	}

	(0, _createClass3.default)(Editable, [{
		key: '_handleChange',
		value: function _handleChange(evt) {
			var val = evt.target.value;
			var div = document.createElement("div");
			div.innerHTML = val;
			var text = div.textContent || div.innerText || "";
			var html = text;
			// if(text.trim().length > 0) {
			this.setState({ html: html, hasChanged: true });
			// }
		}
	}, {
		key: '_submit',
		value: function _submit(event) {
			event.preventDefault();
			this._handleSubmit();
		}
	}, {
		key: '_handleSubmit',
		value: function _handleSubmit() {
			this.setState({ canEdit: true });
			if (this.state.hasChanged) {
				var val = this.state.html;
				if (val.substring(0, 6) === '<span>' && val.substr(val.length - 7) === '</span>') {
					val = val.slice(6, -7);
				}
				this.props.onSubmit(val);
				this.setState({ hasChanged: false });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this,
			    _classNames;

			var styles = require('./Editable.scss');
			return _react2.default.createElement(
				_reactPageClick2.default,
				{ onClick: function onClick() {
						return _this2._handleSubmit();
					} },
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)(styles.editContent, this.props.class, (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.editable, this.state.canEdit), (0, _defineProperty3.default)(_classNames, styles.isEditing, !this.state.canEdit), _classNames)) },
					_react2.default.createElement(_reactContenteditable2.default, {
						html: this.state.html,
						disabled: this.state.canEdit,
						onChange: this._handleChange,
						onClick: function onClick() {
							if (_this2.state.canEdit) {
								_this2.setState({ canEdit: false });
							}
						}
					})
				)
			);
		}
	}]);
	return Editable;
}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, '_submit', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_submit'), _class.prototype)), _class));


Editable.defaultProps = {
	clear: false
};

exports.default = Editable;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Editable/Editable.js
 ** module id = 1090
 ** module chunks = 0
 **/